import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=2e352be2&scoped=true&"
import script from "./ActivityList.vue?vue&type=script&lang=ts&"
export * from "./ActivityList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityList.vue?vue&type=style&index=0&id=2e352be2&lang=scss&scoped=true&"
import style1 from "./ActivityList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e352be2",
  null
  
)

export default component.exports